import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { projects } from '../data/projects';
import './Projects.css';

const Projects = () => {
  const [activeFilter, setActiveFilter] = useState('all');

  const filteredProjects = activeFilter === 'all'
    ? projects
    : projects.filter(project => project.category === activeFilter);

  return (
    <div className="projects">
      <section className="projects-hero">
        <div className="container">
          <div className="projects-hero-content">
            <h1 className="section-title">Our Projects</h1>
            <p className="projects-subtitle">
              Explore our portfolio of innovative structural engineering solutions
            </p>
          </div>
        </div>
      </section>

      <section className="projects-content section">
        <div className="container">
          <div className="filter-section">
            <button
              className={`filter-btn ${activeFilter === 'all' ? 'active' : ''}`}
              onClick={() => setActiveFilter('all')}
            >
              All Projects
            </button>
            <button
              className={`filter-btn ${activeFilter === 'commercial' ? 'active' : ''}`}
              onClick={() => setActiveFilter('commercial')}
            >
              Commercial
            </button>
            <button
              className={`filter-btn ${activeFilter === 'residential' ? 'active' : ''}`}
              onClick={() => setActiveFilter('residential')}
            >
              Residential
            </button>
            <button
              className={`filter-btn ${activeFilter === 'industrial' ? 'active' : ''}`}
              onClick={() => setActiveFilter('industrial')}
            >
              Industrial
            </button>
          </div>

          <div className="projects-grid grid grid-3">
            {filteredProjects.map((project) => (
              <div key={project.id} className="project-card card">
                <div className="project-image">
                  <img src={project.image} alt={project.title} />
                  <div className="project-overlay">
                    <Link to={`/projects/${project.id}`} className="btn btn-primary">
                      View Details
                    </Link>
                  </div>
                </div>
                <div className="project-info">
                  <h3>{project.title}</h3>
                  <p className="project-category">{project.category}</p>
                  <p className="project-description">{project.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Projects; 